import { parseISO } from 'date-fns';
import { transformDate } from '@lib/utils/dateTimeHelpers';

// Mirrors `apps/admin/src/routes/Dashboard/Monitoring/utils/useActions.ts`:
// default period spans from the company's createdAt to today.
//
// Must produce CET-anchored values via `transformDate` (not bare `yyyy-MM-dd`
// via `getFormattedDate`) since the picker and trend-chart date math parse
// this value back with `revertTransformDate`, which mis-parses a bare date
// string as local midnight and drops a day for timezones east of CET.
export default function getDefaultAnalyticsPeriod(
  companyCreatedAt?: string | null,
): string[] {
  const now = new Date();
  const startObj = companyCreatedAt ? parseISO(companyCreatedAt) : now;
  const start = transformDate(startObj);
  const end = transformDate(now, true);
  return [start || '', end || ''];
}
